
export const transformTransactionToInvoice = (transaction) => {
  const amountInRupees = transaction.amount / 100; // Convert paise to rupees
  const baseAmount = transaction.status === 'SUCCESS' 
    ? amountInRupees / 1.18 
    : amountInRupees;
  const gstAmount = amountInRupees - baseAmount;
  
  return {
    id: transaction.orderId || transaction.paymentId,
    paymentId: transaction.paymentId,
    orderId: transaction.orderId,
    date: new Date(transaction.createdAt).toLocaleDateString('en-IN', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }),
    plan: transaction.description || 'Payment',
    baseAmount: baseAmount,
    gstAmount: gstAmount,
    totalAmount: amountInRupees,
    status: transaction.status === 'SUCCESS' ? 'paid' : 'pending',
    currency: transaction.currency,
    subscriptionId: transaction.subscriptionId,
    invoiceId: transaction.invoiceId,
  };
};
